// @ts-strict-ignore
import { Box, List, sprinkles, Text } from "@saleor/macaw-ui-next";
import { Link } from "react-router-dom";

import { MenuItem } from "./Item";
import { SidebarMenuItem } from "./types";
import { isMenuActive } from "./utils";

interface Props {
  menuItem: SidebarMenuItem;
}

export const ItemGroup = ({ menuItem }: Props) => {
  // ✅ include query params
  const fullPath = location.pathname + location.search;

  const hasSubmenuActive = menuItem?.children?.some(item => isMenuActive(fullPath, item));

  const isActive = isMenuActive(fullPath, menuItem) && !hasSubmenuActive;

  const isExpanded = isActive || hasSubmenuActive;

  const handleMenuGroupClick = () => {
    if (menuItem.onClick) {
      menuItem.onClick();
    }
  };

  // ✨ NEW: Dynamically determine the URL. Use parent URL, or fallback to the first child's URL.
  const targetUrl =
    menuItem?.url || (menuItem?.children?.length ? menuItem.children[0].url : undefined);

  return (
    <List.ItemGroup defaultExpanded={isExpanded} data-test-id={`menu-list-item`}>
      <List.ItemGroup.Trigger
        paddingX={2}
        paddingRight={1}
        borderRadius={3}
        size="small"
        active={isActive}
        justifyContent="space-between"
        data-test-id={`menu-item-label-${menuItem.id}`}
        position="relative"
        onClick={handleMenuGroupClick}
        className="sidebar-item-group-trigger"
      >
        {targetUrl ? (
          <Link
            replace={isActive}
            to={targetUrl}
            className={sprinkles({
              width: "100%",
              display: "block",
            })}
          >
            <Box display="flex" alignItems="center" gap={3} paddingY={1.5} borderRadius={3}>
              {menuItem.icon}
              <Text size={3} fontWeight="medium">
                {menuItem.label}
              </Text>
              {menuItem.endAdornment && <Box>{menuItem.endAdornment}</Box>}
            </Box>
          </Link>
        ) : (
          <Box display="flex" alignItems="center" gap={3} paddingY={1.5} borderRadius={3}>
            {menuItem.icon}
            <Text size={3} fontWeight="medium">
              {menuItem.label}
            </Text>
            {menuItem.endAdornment && <Box>{menuItem.endAdornment}</Box>}
          </Box>
        )}
      </List.ItemGroup.Trigger>

      <List.ItemGroup.Content>
        <Box
          borderLeftWidth={1}
          borderLeftStyle="solid"
          borderColor="default1"
          paddingLeft={4}
          marginLeft={4}
          display="flex"
          flexDirection="column"
          marginBottom={2}
          marginTop={1}
          gap="px"
        >
          {menuItem.children?.map(child => (
            <MenuItem menuItem={child} key={child.id} />
          ))}
        </Box>
      </List.ItemGroup.Content>
    </List.ItemGroup>
  );
};
